import React from "react"
import ContentLoader from "react-content-loader"

const Skeleton = (props) => (
    <ContentLoader
        speed={2}
        // width={320}
        height={49}
        // viewBox="0 0 320 57"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
    >
    <rect x="0" y="10" rx="0" ry="0" width="100%" height="29" />
  </ContentLoader>
)

export default Skeleton